import { type AnyBackendMessageStages } from '../../../../create-placement/types';

export const defaultBackendPlacementMessageStages: AnyBackendMessageStages = {
	// add stages here to default across all message backends
};
